export default "__VITE_ASSET__CIIgScJq__"